import { Box, Fade } from '@mui/material';
import { Film, FinderResultsRequest } from '@/services';
import InfiniteScroll, {
  Props as InfiniteScrollProps,
} from 'react-infinite-scroll-component';
import MovieCollapse, { MovieCollapseProps } from './movie-collapse';
import { FC, useEffect, useState } from 'react';

import CustomizedCircularProgress from '@/components/shared/customized-circular-progress';
import { isString } from '@alpha.apps/react-common';
import { MovieLoaderWrapper } from './movie-loader-wrapper';

export interface MovieCollapseListProps {
  movies: Film[];
  hasMore: boolean;
  fetchMovies: () => void;
  isFetching?: boolean;
  isFetchingNextPage?: boolean;
  infiniteScrollProps?: Partial<InfiniteScrollProps>;
  filters?: FinderResultsRequest;
  showLoader?: boolean;
  callOnFilmHasBeenStarted?: () => void;
  showTimeDate?: string;
}

export const MovieCollapseList: FC<
  MovieCollapseListProps & Pick<MovieCollapseProps, 'showExperiencesBy'>
> = ({
  movies,
  hasMore,
  filters,
  fetchMovies,
  showExperiencesBy,
  isFetching,
  isFetchingNextPage,
  infiniteScrollProps = {},
  showLoader,
  callOnFilmHasBeenStarted,
  showTimeDate,
}) => {
  const [activeAccordion, setExpanded] = useState<number | boolean>(null);

  const handleChange = (panelNumber: number) => () => {
    if (activeAccordion === panelNumber) setExpanded(null);
    else setExpanded(panelNumber);
  };

  // useEffect(() => {
  //   setExpanded(0);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [movies]);

  useEffect(() => {
    if (isString(showTimeDate)) {
      setExpanded(null);
    }
  }, [showTimeDate]);

  return (
    <>
      {movies?.length > 0 ? (
        <InfiniteScroll
          dataLength={movies.length}
          next={fetchMovies}
          hasMore={hasMore}
          loader={
            hasMore &&
            isFetchingNextPage && (
              <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
                <CustomizedCircularProgress size={40} thickness={4} />
              </Box>
            )
          }
          style={{
            overflow: 'unset',
          }}
          {...infiniteScrollProps}
        >
          {movies?.map((movie: Film, index: number) => (
            <Fade key={movie.id} appear in={true} timeout={300}>
              <Box>
                <MovieCollapse
                  movie={movie}
                  filters={filters}
                  isExpanded={activeAccordion === index}
                  handleChange={handleChange(index)}
                  showExperiencesBy={showExperiencesBy}
                  showLoader={showLoader}
                  callOnFilmHasBeenStarted={callOnFilmHasBeenStarted}
                  showTimeDate={showTimeDate}
                />
              </Box>
            </Fade>
          ))}
        </InfiniteScroll>
      ) : (
        isFetching && (
          <MovieLoaderWrapper
            innerBox={{
              width: '100%',
              height: '160px',
              marginTop: '50px',
              display: 'flex',
              justifyContent: 'center',
            }}
          />
        )
      )}
    </>
  );
};
